import { ColumnDef } from "@tanstack/react-table";
import { useEffect, useState } from "react";
import api from "../../api/axios";
import { DataTable } from "../data-table/data-table";

export function Users() {

    const [text, setText] = useState('');
    const [textDelete, setTextDelete] = useState('');
    const [userForDeletion, setUserForDeletion] = useState<any>(null);
    const [users, setUsers] = useState<any[]>([]);

    const fetchUsers = async () => {
        try {
            const response = await api.get('/users');

            if (response.status !== 200) {
                throw new Error('Network response was not ok');
            }

            setUsers(response.data);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    }

    useEffect(() => {
        fetchUsers();
    }, []);

    useEffect(() => {
        if (!textDelete) {
            setUserForDeletion(null);
            return;
        }

        const timeout = setTimeout(() => {
            api.get(`/checkUserForManager/${textDelete}`)
                .then(response => setUserForDeletion(response.data))
                .catch(error => console.error("Error fetching user:", error));
        }, 300);

        return () => clearTimeout(timeout);
    }, [textDelete]);

    const deleteUser = async () => {
        try {
            const response = await api.delete(`/users/${textDelete}`);

            alert(response.data?.message);
            
            fetchUsers();
            setTextDelete('');
        } catch (error) {
            console.error('Error deleting user:', error);
        }
    }

    const columns: ColumnDef<any>[] = [
        {
            accessorKey: 'first_name',
            header: 'Vorname',
        },
        {
            accessorKey: 'last_name',
            header: 'Nachname',
        },
        {
            accessorKey: 'email',
            header: 'E-Mail',
        },
        {
            accessorKey: 'name',
            header: 'Unternehmen'
        }
    ];

    if (!users || users.length === 0) {
        return (
            <div className="users">
                <p>Es wurden keine Benutzer gefunden.</p>
            </div>
        );
    }

    const getUserForDeletion = () => {
        if (!userForDeletion) {
            return <></>;
        }

        if (userForDeletion.count === 0) {
            return <p>Es wurde kein Benutzer mit der E-Mail {text} gefunden.</p>;
        }

        if (userForDeletion.count > 1) {
            return <p>Es wurden {userForDeletion.count} Benutzer mit der E-Mail {text} gefunden. Bitte melden Sie sich beim Support!.</p>;
        }

        return <>
            {userForDeletion.count > 1 && <p>ACHTUNG: Es wurden mehrere Benutzer ({userForDeletion.count}) gefunden!!!!</p>}
            <p>Vorname: {userForDeletion.user.first_name}</p>
            <p>Nachname: {userForDeletion.user.last_name}</p>
            <p>E-Mail: {userForDeletion.user.email}</p>
            <p>Unternehmen: {userForDeletion.user.name}</p>
            <button onClick={() => deleteUser()}>User löschen (Nur in unserer DB)</button>
        </>
    }

    return (
        <div className="users">
            <h4>User-Löschung</h4>
            <div className="delete-user-container">
                <input
                    id="filterDelete"
                    placeholder="E-Mail Delete"
                    type="text"
                    value={textDelete}
                    onChange={(e) => setTextDelete(e.target.value.replace(/\s+/g, ""))}
                />
                {getUserForDeletion()}
            </div>
            <hr></hr>
            <h4>Benutzer ({users.length})</h4>
            <input
                id="myInput"
                className="search-input"
                placeholder="Filter"
                type="text"
                value={text}
                onChange={(e) => setText(e.target.value.replace(/\s+/g, ""))}
            />
            <DataTable
                columns={columns}
                data={users.filter((user) => text === "" || user.first_name.toLowerCase().includes(text.toLowerCase()) || user.last_name.toLowerCase().includes(text.toLowerCase()) || user.email.toLowerCase().includes(text.toLowerCase()))}
            />
        </div>
    );
}